import { Record, Union } from "../../fable_modules/fable-library-js.4.18.0/Types.js";
import { array_type, record_type, int32_type, float64_type, union_type, lambda_type, unit_type, string_type, bool_type, class_type } from "../../fable_modules/fable-library-js.4.18.0/Reflection.js";
import { toProps } from "../../Interop/React.fs.js";
import * as react from "react";
import { AutoComplete as AutoComplete_1, InputNumber as InputNumber_1, Input as Input_1 } from "antd";
import { FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E } from "../../fable_modules/Fable.React.9.4.0/Fable.React.FunctionComponent.fs.js";
import { value as value_1 } from "../../fable_modules/fable-library-js.4.18.0/Option.js";
import { defaultOf, int32ToString } from "../../fable_modules/fable-library-js.4.18.0/Util.js";
import Input_2 from "../../../src/Components/Input/Input.css";
import { HTMLAttr } from "../../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { ButtonProps, Button } from "../../Interop/Antd/Misc.fs.js";
import { singleton, empty, ofArray } from "../../fable_modules/fable-library-js.4.18.0/List.js";
import { PlusOutlined, MinusOutlined } from "../../Interop/Antd/Icon.fs.js";
import { keyValueList } from "../../fable_modules/fable-library-js.4.18.0/MapUtil.js";

export class InputProps extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AddonAfter", "AddonBefore", "AllowClear", "Placeholder", "AutoComplete", "AutoFocus", "ClassName", "DefaultValue", "Disabled", "Focus", "OnBlur", "OnChange", "OnPressEnter", "Prefix", "Size", "Suffix", "Type", "Value", "Bordered"];
    }
}

export function InputProps_$reflection() {
    return union_type("Loop54.Portal.WebUI.Components.Input.InputProps", [], InputProps, () => [[["Item", class_type("Fable.React.ReactElement")]], [["Item", class_type("Fable.React.ReactElement")]], [["Item", bool_type]], [["Item", string_type]], [["Item", string_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", string_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", lambda_type(class_type("Browser.Types.Event", undefined), unit_type)]], [["Item", lambda_type(class_type("Browser.Types.Event", undefined), unit_type)]], [["Item", lambda_type(class_type("Browser.Types.Event", undefined), unit_type)]], [["Item", class_type("Fable.React.ReactElement")]], [["Item", string_type]], [["Item", class_type("Fable.React.ReactElement")]], [["Item", string_type]], [["Item", string_type]], [["Item", bool_type]]]);
}

export function Input(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(Input_1, props_1, ...elems);
}

export class SearchProps extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AddonAfter", "AddonBefore", "AllowClear", "ClassName", "DefaultValue", "OnChange", "OnSearch", "Prefix", "Size"];
    }
}

export function SearchProps_$reflection() {
    return union_type("Loop54.Portal.WebUI.Components.Input.SearchProps", [], SearchProps, () => [[["Item", class_type("Fable.React.ReactElement")]], [["Item", class_type("Fable.React.ReactElement")]], [["Item", bool_type]], [["Item", string_type]], [["Item", string_type]], [["Item", lambda_type(class_type("Browser.Types.Event", undefined), unit_type)]], [["Item", lambda_type(string_type, unit_type)]], [["Item", class_type("Fable.React.ReactElement")]], [["Item", string_type]]]);
}

export function Search(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(Input_1.Search, props_1, ...elems);
}

export class TextAreaProps extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AutoSize", "ClassName", "DefaultValue", "Disabled"];
    }
}

export function TextAreaProps_$reflection() {
    return union_type("Loop54.Portal.WebUI.Components.Input.TextAreaProps", [], TextAreaProps, () => [[["Item", bool_type]], [["Item", string_type]], [["Item", string_type]], [["Item", bool_type]]]);
}

export function TextArea(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(Input_1.TextArea, props_1, ...elems);
}

export class InputGroupProps extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Compact", "Size"];
    }
}

export function InputGroupProps_$reflection() {
    return union_type("Loop54.Portal.WebUI.Components.Input.InputGroupProps", [], InputGroupProps, () => [[["Item", bool_type]], [["Item", string_type]]]);
}

export function InputGroup(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(Input_1.Group, props_1, ...elems);
}

export class InputNumberProps$1 extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AutoFocus", "Bordered", "ClassName", "DecimalSeparator", "DefaultValue", "Disabled", "Formatter", "Keyboard", "Max", "Min", "Parser", "Precision", "ReadOnly", "Size", "Step", "StringMode", "Value", "OnChange", "OnPressEnter", "Controls"];
    }
}

export function InputNumberProps$1_$reflection(gen0) {
    return union_type("Loop54.Portal.WebUI.Components.Input.InputNumberProps`1", [gen0], InputNumberProps$1, () => [[["Item", bool_type]], [["Item", bool_type]], [["Item", string_type]], [], [["Item", string_type]], [["Item", bool_type]], [["Item", lambda_type(string_type, string_type)]], [["Item", bool_type]], [["Item", float64_type]], [["Item", float64_type]], [["Item", lambda_type(string_type, gen0)]], [["Item", int32_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", gen0]], [["Item", bool_type]], [["Item", gen0]], [["Item", lambda_type(string_type, unit_type)]], [["Item", lambda_type(class_type("Browser.Types.Event", undefined), unit_type)]], [["Item", bool_type]]]);
}

export function InputNumber(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(InputNumber_1, props_1, ...elems);
}

export class NumberInputWithButtonsProps extends Record {
    constructor(minValue, maxValue, currentValue, onChange) {
        super();
        this.minValue = (minValue | 0);
        this.maxValue = (maxValue | 0);
        this.currentValue = (currentValue | 0);
        this.onChange = onChange;
    }
}

export function NumberInputWithButtonsProps_$reflection() {
    return record_type("Loop54.Portal.WebUI.Components.Input.NumberInputWithButtonsProps", [], NumberInputWithButtonsProps, () => [["minValue", int32_type], ["maxValue", int32_type], ["currentValue", int32_type], ["onChange", lambda_type(int32_type, unit_type)]]);
}

export const NumberInputWithButtons = FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E((((value_1("/home/tcagent/agent/work/fc6800de859d0248/portal/Loop54.Portal.WebUI/src/Components/Input/Input.fs") + "#L") + int32ToString(value_1(116))) + ";") + "Loop54.Portal.WebUI.Components.Input.NumberInputWithButtonsProps", value_1("NumberInputWithButtons"), (props) => {
    const props_1 = [new HTMLAttr(64, [Input_2.numberInputWithControls])];
    const children = [Button(ofArray([new ButtonProps(0, [Input_2.numberInputWithControlsButton]), new ButtonProps(5, [(_arg) => {
        if (props.currentValue > props.minValue) {
            props.onChange(props.currentValue - 1);
        }
    }]), new ButtonProps(1, [props.currentValue <= props.minValue])]), singleton(MinusOutlined(empty(), empty()))), InputNumber(ofArray([new InputNumberProps$1(2, [Input_2.numberInputWithControlsInput]), new InputNumberProps$1(9, [props.minValue]), new InputNumberProps$1(8, [props.maxValue]), new InputNumberProps$1(16, [props.currentValue]), new InputNumberProps$1(17, [(value) => {
        if (value === defaultOf()) {
        }
        else {
            props.onChange(value);
        }
    }]), new InputNumberProps$1(19, [false])]), empty()), Button(ofArray([new ButtonProps(0, [Input_2.numberInputWithControlsButton]), new ButtonProps(5, [(_arg_1) => {
        if (props.currentValue < props.maxValue) {
            props.onChange(props.currentValue + 1);
        }
    }]), new ButtonProps(1, [props.currentValue >= props.maxValue])]), singleton(PlusOutlined(empty(), empty())))];
    return react.createElement("div", keyValueList(props_1, 1), ...children);
}, undefined, undefined, "Of");

export class AutoCompleteOption extends Record {
    constructor(label, value) {
        super();
        this.label = label;
        this.value = value;
    }
}

export function AutoCompleteOption_$reflection() {
    return record_type("Loop54.Portal.WebUI.Components.Input.AutoCompleteOption", [], AutoCompleteOption, () => [["label", class_type("Fable.React.ReactElement")], ["value", string_type]]);
}

export class AutoCompleteProps extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Value", "DefaultValue", "Options", "Placeholder", "AllowClear", "OnSearch", "OnSelect", "OnChange", "ClassName"];
    }
}

export function AutoCompleteProps_$reflection() {
    return union_type("Loop54.Portal.WebUI.Components.Input.AutoCompleteProps", [], AutoCompleteProps, () => [[["Item", string_type]], [["Item", string_type]], [["Item", array_type(AutoCompleteOption_$reflection())]], [["Item", string_type]], [["Item", bool_type]], [["Item", lambda_type(string_type, unit_type)]], [["Item", lambda_type(string_type, unit_type)]], [["Item", lambda_type(string_type, unit_type)]], [["Item", string_type]]]);
}

export function AutoComplete(props, children) {
    const props_1 = toProps(props);
    return react.createElement(AutoComplete_1, props_1, ...children);
}

